import { useContext } from 'react';
import { Context } from './Context';
export function useInsights() {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useInsights must be used within InsightsProvider');
    }
    return context;
}
